// backend RoleType 두 등급(admin|member). 로그인 전과 세션 미복원 상태는 등급이 아니라 `null` 이다.
// "등급 없음"을 등급처럼 다루면 그 값이 권한 판정에 섞인다.
export type UserRole = "admin" | "member";

const userRoles = ["admin", "member"] as const satisfies readonly UserRole[];

export function isUserRole(value: unknown): value is UserRole {
  return typeof value === "string" && userRoles.includes(value as UserRole);
}

// 등급 게이트. 상하 관계가 아니라 정확히 일치하는지 비교한다.
//   - 요구 등급이 없으면 누구나 통과한다. 로그인 여부는 라우터 가드가 따로 검사한다.
//   - 요구 등급이 있으면 사용자 등급이 있고 요구 등급에 포함되어야 통과한다.
export function hasAnyUserRole(
  role: UserRole | null,
  requiredRoles: readonly UserRole[] | undefined,
): boolean {
  if (requiredRoles == null || requiredRoles.length === 0) {
    return true;
  }
  return role !== null && requiredRoles.includes(role);
}

// 서버가 산출해 `/v1/me` 로 보내는 권한 모음.
export type MePermissions = {
  // 공유 자원(canonical dataset·embodiment 카탈로그·label) 삭제 권한. admin 만 가진다.
  can_delete_shared: boolean;
  // Evaluation 표면(페이지·Isaac Evaluation 설정) 사용 권한. BE가 research 그룹 소속 여부로
  // 산출한다. FE는 어느 그룹이 권한을 주는지 모른다.
  can_use_evaluation: boolean;
  can_use_schedule_operations?: boolean;
  can_manage_schedules?: boolean;
};
